import { useQuery } from '@tanstack/react-query';

import type { ClientCardRefundQuote } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CLIENT_CARDS_QUERY_KEY = 'client_cards';

export const CLIENT_CARD_REFUND_QUOTE_QUERY_KEY = 'client_card_refund_quote';

export const useClientCardRefundQuoteQuery = (url: string) =>
  useQuery({
    queryKey: [CLIENT_CARD_REFUND_QUOTE_QUERY_KEY, url],
    queryFn: () =>
      HttpClient.request<ClientCardRefundQuote>({ method: 'GET', url }),
    enabled: false,
    refetchOnWindowFocus: false,
    gcTime: 0,
    staleTime: 0,
    retry: false,
  });
